import type {Property} from "../types";

export function mergePropertiesById(...lists: Property[][]) {
  const byId = new Map<number, Property>();
  for (const list of lists) {
    for (const property of list) {
      byId.set(property.id, property);
    }
  }
  return [...byId.values()].sort((a, b) => a.name.localeCompare(b.name));
}
